import styled from 'styled-components';

export const SectionContent = styled.div`
  display: block;
  width: 100%;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-top: 32px;
  padding-bottom: 40px;
`;

export const Section = styled.section`
  display: block;
  width: 100%;
`;

export const SectionHeader = styled.header`
  margin-bottom: 12px;
`;
